export default "__VITE_ASSET__BJAY2LHf__"